import React from "react";
import { Waitlist } from "@clerk/clerk-react";
import s from "./styles.module.scss";

const WaitlistPage = () => {
  return (
    <div className={s.authContainer}>
      <Waitlist
        afterJoinWaitlistUrl="/waitlist-success"
        signInUrl="/sign-in"
        appearance={{
          elements: {
            socialButtons: s.socialButtons,
            logoBox: s.logoBox,
            headerTitle: s.headerTitle,
            card: s.card,
            cardBox: s.cardBox,
            main: s.main,
            formFieldLabel: s.formFieldLabel,
            formFieldInput: s.formFieldInput,
            formButtonPrimary: s.formButtonPrimary,
            footerAction: s.footerAction,
            footer: s.footer,
            form: s.form,
          },
          layout: {
            socialButtonsPlacement: "top",
            socialButtonsVariant: "blockButton",
          },
        }}
      />
    </div>
  );
};

export default WaitlistPage;
